
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BaseBOB.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import {
    ProjectWizardPromoter1Selector,
    ProjectWizardPromoter2Selector,
    ProjectWizardContactPersonSelector
} from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";

class BaseBOB extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private existingEntity: VAM2types.EvProjectEntity_Extended = null;
    private promoter1SelectorForm: MdsLax<InstanceType<ReturnType<typeof _StatefulSection>>>;
    private contactPersonSelectorForm: MdsLax<InstanceType<typeof ProjectWizardContactPersonSelector>>;

    afterSetData() {
        let data = this.sourceData as VAM2types.EvProjectEntity_Extended;

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;

        } else {
            this._onPrivilegesLoaded();
        }
        this.setStartupState("ready");
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChanged_EvProjectName(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }

    private _onChanged_RefPromoter1(key: string, newValue: VAM2types.EvProject_PromoterEntity, oldValue: VAM2types.EvProject_PromoterEntity) {
        //console.debug(this.id + " _onChanged_RefPromoter1" + " | key", key, "newValue", newValue, "oldValue", oldValue);
        let currentValue: VAM2types.EvProject_PromoterEntity = this.promoter1SelectorForm.getChangedData();

        if (currentValue && currentValue.ref_address) {
            this.disableNode(this.contactPersonSelectorForm, false);
            this.contactPersonSelectorForm.setData(currentValue);
            this.contactPersonSelectorForm.setNullValue()

        } else {
            this.contactPersonSelectorForm.setNullValue()
            this.disableNode(this.contactPersonSelectorForm, true);
        }
    }

    private _onPrivilegesLoaded() {
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.setStartupState("loading");
        this.addOnchanged("ev_project_name", lang.hitch(this, this._onChanged_EvProjectName));
        //this.addOnchanged("ref_promoter_1", lang.hitch(this, this._onChanged_RefPromoter1));

        this.contactPersonSelectorForm.enableEntityViewButton(true);
        //this.promoter1SelectorForm.on("promoter_1_ref_address", lang.hitch(this, this._onChanged_RefPromoter1))
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BaseBOB);